import "./App.css";
import { CompanyPreviewPanel } from "./components/company/company-preview-panel-sheet";
import { SupportLauncher } from "./components/support/support-launcher";
import { useDeviceFormat } from "./hooks/useDeviceFormat";
import LayoutDesktop from "./LayoutDesktop";
import LayoutMobile from "./LayoutMobile";

export type LayoutProps = {
  showNavMain?: boolean;
  showNavSearch?: boolean;
  showTeamSwitcher?: boolean;
  showTeamTrial?: boolean;
  navLinkToTheRoot?: boolean;
  children?: React.ReactNode;
};

export const Layout = ({
  showNavMain = true,
  showTeamSwitcher = true,
  showTeamTrial = true,
  navLinkToTheRoot = true,
  children,
}: LayoutProps) => {
  const { isMobile } = useDeviceFormat();

  return (
    <>
      {isMobile ? (
        <LayoutMobile showNavMain={showNavMain}>{children}</LayoutMobile>
      ) : (
        <LayoutDesktop
          showNavMain={showNavMain}
          showTeamSwitcher={showTeamSwitcher}
          showTeamTrial={showTeamTrial}
          navLinkToTheRoot={navLinkToTheRoot}
        >
          {children}
        </LayoutDesktop>
      )}
      {/* Singleton preview panel: opened from any surface via companyPreviewPanelStore. */}
      <CompanyPreviewPanel />
      {/* Singleton placement driver for the permanent support bubble. */}
      <SupportLauncher />
    </>
  );
};
